/**
 * Green outlined Cancel button for form dialogs/drawers.
 * The theme greys out outlined buttons inside DialogActions, so these rules use !important.
 */
const cancelButtonSx = {
  minWidth: '140px !important',
  borderColor: '#059669 !important',
  color: '#059669 !important',
  backgroundColor: '#fff !important',
  '&:hover': { backgroundColor: '#ecfdf5 !important', borderColor: '#047857 !important', color: '#047857 !important' },
};

export default cancelButtonSx;
